"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _sitecoreJssReact = require("@sitecore-jss/sitecore-jss-react");
var _headTags = _interopRequireDefault(require("../../components/headTags"));
var _Footer = _interopRequireDefault(require("../../components/Nav/Footer"));
var _Header = _interopRequireDefault(require("../../components/Nav/Header"));
var _lodash = require("lodash");
var _richTextField = require("../../lib/richTextField");
var _globalDataContext = require("../../lib/globalDataContext");
var _OnDemandScripts = _interopRequireDefault(require("../../components/OnDemandScripts"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
  APP LAYOUT
  This is where the app's HTML structure and root placeholders should be defined.

  All routes share this root layout by default (this could be customized in RouteHandler),
  but components added to inner placeholders are route-specific.
*/

var DefaultBlogLayout = props => {
  var route = props.route;
  (0, _globalDataContext.setGlobalData)(props);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_headTags.default, props.headTagsProps), /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.VisitorIdentification, null), /*#__PURE__*/_react.default.createElement(_Header.default, {
    route: route,
    params: props.componentProps,
    headTagsProps: props.headTagsProps
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
    name: "main-content-full-body",
    renderingName: route.name,
    rendering: route,
    params: props.componentProps,
    renderingFields: props.route.fields
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-spacing"
  }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
    name: "main-content",
    rendering: route,
    params: props.componentProps
  })), /*#__PURE__*/_react.default.createElement(_Footer.default, {
    fields: route.fields,
    componentParams: props.componentProps,
    params: props.headTagsProps
  }), /*#__PURE__*/_react.default.createElement(_OnDemandScripts.default, {
    scriptList: route.fields.ScriptOnDemand
  }));
};
var _default = exports.default = DefaultBlogLayout;